import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

import { Button } from '@/components/ui/button';
    import { ChevronRight, LoaderCircle } from 'lucide-vue-next';
    import { ref } from 'vue';
    import axios from 'axios';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';
    import { EconomicAccount } from '@/types';

    interface Props {
        form: any;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'FetchFromEconomicButton',
  props: {
    form: {}
  },
  emits: ["accounts-loaded"],
  setup(__props: any, { emit: __emit }) {

    const { t } = useI18n();

    const props = __props;

    const isLoading = ref(false);

    const emit = __emit;

    const loadApiData = async () => {
        isLoading.value = true;
        try {
            const { data } = await axios.post(route('v2.companies.endpoint.load'), {
                api_token: props.form.api_token,
            });
            handleApiSuccess(data.data);
            handleApiAccounts(data.accounts);
        } catch (error: any) {
            console.error('API call failed:', error);
            handleApiError(error);
        } finally {
            isLoading.value = false;
        }
    };

    const handleApiError = (error: any) => {
        const message = error.response.data.message;
        if (message.includes('401 Unauthorized')) {
            toast.error(t('companies.economic_unauthorized'));
        } else {
            toast.error(t('forms.system_error'));
        }
    };

    const handleApiSuccess = (data: any) => {
        const merged = { ...data };

        if (data.economic_data) {
            merged.cvr = data.economic_data.cvr;
            merged.website = data.economic_data.website;
            merged.economic_number = data.economic_data.economic_number;
        }

        for (const key in merged) {
            if (key in props.form && merged[key] !== undefined) {
                props.form[key] = merged[key];
            }
        }
    };

    const handleApiAccounts = (accounts: EconomicAccount[]) => {
        emit(
            'accounts-loaded',
            accounts.map((account) => ({
                ...account,
                id: Number(account.accountNumber),
            })),
        );
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    variant: "ghost_primary",
    size: "xs",
    onClick: _withModifiers(loadApiData, ["prevent"]),
    disabled: _ctx.form.endpoint !== 'economic' || !_ctx.form.api_token || isLoading.value
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('forms.load')) + " ", 1),
      (isLoading.value)
        ? (_openBlock(), _createBlock(_unref(LoaderCircle), {
            key: 0,
            class: "animate-spin"
          }))
        : (_openBlock(), _createBlock(_unref(ChevronRight), {
            key: 1,
            class: "text-primary"
          }))
    ]),
    _: 1
  }, 8, ["disabled"]))
}
}

})